import api from "./api";
import StorageService from "./StorageService";

const MemberService = {
  getAll: async (page = 1, limit = 10, filters = {}) => {
    try {
      let url = `/members?page=${page}&limit=${limit}`;
      const res = await api.get(url);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to fetch members");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  getById: async (id) => {
    try {
      const res = await api.get(`/members/${id}`);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to fetch member");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  create: async (data) => {
    try {
      const payload = { ...data, createdBy: StorageService.loginData().employeeId };
      const res = await api.post("/members", payload);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to create member");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  update: async (id, data) => {
    try {
      const payload = { ...data, updatedBy: StorageService.loginData().employeeId };
      const res = await api.put(`/members/${id}`, payload);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to update member");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  updateStatus: async (id, status) => {
    try {
      const res = await api.patch(`/members/${id}/status`, { status, updatedBy: StorageService.loginData().employeeId });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to update member status");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  }
};

export default MemberService;
